module.exports = __webpack_public_path__ + "static/CalibreWeb-Regular-d3ffea70631534136deb88da69a0e6c1.woff2";